import React from 'react'
import './SortInfo.css'
export default function MergeSort() {
  return (
    <div>
      <div className='sort-info'>
      <div className="sort-name">
          Name : Merge Sort
        </div>
        <div className="sort-time">
          Time Complexity : O(nlog(n))
        </div>
    </div>
    </div>
  )
}
